import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { BriefcaseAccount,CheckboxMarked  } from 'mdi-material-ui';
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

const ExpansionPanel = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
    root: {
        backgroundColor: 'rgba(0, 0, 0, .03)',
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiExpansionPanelDetails);

export default function Skills() {
    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = panel => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    return (
        <div>
            <Typography component="div">
                <div style={{ display: "flex", alignItems: "center", marginLeft: 10 }}>
                    <BriefcaseAccount color="primary" style={{ fontSize: 40 }} />
                    <Box fontWeight="bold" fontSize={40} m={2}>
                        work expriences
                    </Box>
                </div>
            </Typography>
            <div>
                <ExpansionPanel square expanded={expanded === 'panel1'} onChange={handleChange('panel1')} style={{background:"#1a1c1d"}}>
                    <ExpansionPanelSummary aria-controls="panel1d-content" id="panel1d-header">
                        <Typography color="primary"><CheckboxMarked  color="primary" style={{fontSize:15}}/> Researcher at KN2C Robatic Lab (Soccer 2D Simulation) [2017-2018]</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Typography component="div">
                            <Box fontSize={16} m={1} style={{color:'#ffffff'}} textAlign="justify">
                                The team website: <a href="http://kn2c.aras.kntu.ac.ir/rcss2d/" rel="noopener noreferrer" target="_blank">kn2c.aras.kntu.ac.ir/rcss2d</a>
                            <ul>
                                <li>Cofounded the soccer 2D simulation team for the first time at the KN2C lab.</li>
                                <li>Read and made documentation for the simulator server and base.</li>
                                <li>Implemented artificial algorithms and improved the algorithms used previously in the code.</li>
                                <li>Worked with neural network and q-learning algorithm for improving the offense system of the team.</li>
                                <li>Participated in monthly meeting with the supervisior and reported my work.</li>
                            </ul>
                            </Box>
                        </Typography>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel square expanded={expanded === 'panel2'} onChange={handleChange('panel2')} style={{background:"#1a1c1d"}}>
                    <ExpansionPanelSummary aria-controls="panel2d-content" id="panel2d-header">
                        <Typography color="primary"><CheckboxMarked  color="primary" style={{fontSize:15}}/> Teaching Assistant (Design and Analysis of Algorithms) [2019]</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Typography component="div">
                            <Box fontSize={16} m={1} style={{color:'#ffffff'}} textAlign="justify">
                            I was accepted for this job because I had got an A+ in this course. Also, I had participated in ACM ICPC competitions, so I had experience with coding and algorithms.
                            <ul>
                                <li>Held recitation classes for the students and solved the chalenging problems.</li>
                                <li>Invigilated the midterm exam.</li>
                                <li>Designed project for the end of the semester.</li>
                                <li>Gave feedback to students about their projects and homework.</li>
                            </ul>
                            </Box>
                        </Typography>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel square expanded={expanded === 'panel3'} onChange={handleChange('panel3')} style={{background:"#1a1c1d"}}>
                    <ExpansionPanelSummary aria-controls="panel3d-content" id="panel3d-header">
                        <Typography color="primary"><CheckboxMarked  color="primary" style={{fontSize:15}}/> Freelance Project (Commercial Website for Home Decoration) [2019]</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Typography component="div">
                            <Box fontSize={16} m={1} style={{color:'#ffffff'}} textAlign="justify">
                                This project was our first collabertion as the <a href="https://brilacasck.ir/" rel="noopener noreferrer" target="_blank">brilacasck</a> team. It was completed in June and its domain is <a href="https://vornadecor.com" rel="noopener noreferrer" target="_blank">vornadecor.com</a>
                                <ul>
                                    <li>Designed the front-end of the website.</li>
                                    <li>Implemented the front-end using React and similar technologies.</li>
                                    <li>Connected the front-end to the back-end of the website.</li>
                                </ul>
                            </Box>
                        </Typography>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </div>
        </div>
    )
}